import { render } from "./sucursalesPorHora.vue?vue&type=template&id=f96c5d9e"
import script from "./sucursalesPorHora.vue?vue&type=script&lang=js"
export * from "./sucursalesPorHora.vue?vue&type=script&lang=js"

import "./sucursalesPorHora.vue?vue&type=style&index=0&id=f96c5d9e&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__